import React, { useMemo } from 'react'

import { formatHourOfDayOptions } from 'cube/components/HourRangeSelect'
import { equals } from 'ramda'

import { Select, SelectOption } from '@driftt/dds'

interface HourOfDaySelectProps {
  isDisabled: boolean
  hourOfDay: number | null
  onChange: (selectedValue: number) => void
}

/**
 *
 * Handles hour of day selection with values represented as 0-23.
 *
 * @param {HourOfDaySelectProps} HourRangeSelectProps
 * @returns {JSX.Element} JSX.Element
 */
export const HourOfDaySelect = ({
  isDisabled,
  hourOfDay,
  onChange,
}: HourOfDaySelectProps) => {
  const hourOfDayOptions = useMemo(() => formatHourOfDayOptions(), [])

  const selectedHourOfDayOption = useMemo(
    () =>
      hourOfDayOptions.find((option) =>
        equals(option.value, hourOfDay?.toString())
      ),
    [hourOfDay, hourOfDayOptions]
  )

  return (
    <Select
      label="Select hour of day"
      placeholder="Select..."
      hideLabel
      options={hourOfDayOptions}
      value={selectedHourOfDayOption}
      onChange={(option) => {
        const selectedOption = option as SelectOption<string>
        onChange(Number(selectedOption.value))
      }}
      isDisabled={isDisabled}
      size="small"
      isClearable={false}
    />
  )
}
